wbApp.directive('wbAvailabilityScheduleEditor', [
    function () {

        return {
            restrict: 'A',
            priority: 1,
            scope: {
                ngModel: '='
            },
            templateUrl: 'users/directives/availability-schedule-editor.html',
            link: function (scope, elem, attrs) {

                scope.cols = [];
                for (var i = 0; i < 24 * 2; i++) {
                    var minutes = (i * 60 / 2);
                    var mday = moment(scope.ngModel.day).add(minutes, 'm');

                    var idx = _.find(scope.ngModel.periods, function (p) {
                        return p.start <= mday && p.end > mday;
                    });

                    var selected = idx !== undefined;
                    var grpIdx = idx + 1;

                    scope.cols.push({
                        idx: i,
                        selected: selected,
                        grpIndex: grpIdx
                    });
                }

                scope.hours = [];
                for (var i = 0; i < 24; i++) {
                    scope.hours.push(i);
                }


                scope.isSelecting = false;
                scope.isDeselecting = false;
                scope.startIdx = null;
                scope.lastSelectedCell = null;
                scope.grpIndex = 0;

                scope.onMouseDown = function (col) {
                    if (col.selected) {
                        scope.isSelecting = false;
                        scope.isDeselecting = true;
                    } else {
                        scope.isSelecting = true;
                        scope.isDeselecting = false;
                    }
                    scope.startIdx = col.idx;
                    scope.lastSelectedCell = col;                    

                    markAllToIndex(col.idx);
                }

                scope.onMouseUp = function (col) {
                    scope.isSelecting = false;
                    scope.isDeselecting = false;
                    scope.startIdx = null;
                    scope.lastSelectedCell = null;

                    for (var i = 0; i < 24 * 2; i++) {
                        scope.cols[i].changed = false;
                    }
                }

                function getPeriodByIndex(idx) {
                    if (!scope.ngModel.periods || scope.ngModel.periods.length < idx) {
                        scope.ngModel.periods.push({});
                    }
                    return scope.ngModel.periods[idx - 1];
                }

                function colAssignPeriod(col, s, e) {                    
                    var period = getPeriodByIndex(col.grpIndex);
     
                    period.start = moment(scope.ngModel.day).add((s * 60 / 2), 'm');
                    period.end = moment(scope.ngModel.day).add(((e + 1) * 60 / 2), 'm');

                    if (period.start.isBefore(period.end, 'day')) {
                        period.end.subtract(1, 'second');
                    }
                }

                function resetPeriods() {
                    scope.ngModel.periods = [];
                }

                function markAllToIndex(idx) {

                    resetPeriods();

                    if (scope.isSelecting || scope.isDeselecting) {
                        var s = scope.startIdx <= idx ? scope.startIdx : idx;
                        var e = scope.startIdx <= idx ? idx : scope.startIdx;

                        scope.grpIndex = 0;

                        var lastSelectedIdx = -2;
                        var grpStart = 0;

                        for (var i = 0; i < 24 * 2; i++) {
                            var col = scope.cols[i];
                            if (i >= s && i <= e) {                                
                                if (scope.isSelecting) {
                                    col.selected = true;
                                    col.changed = true;
                                } else if (scope.isDeselecting) {
                                    col.selected = false;
                                    col.changed = true;
                                }
                            } else {
                                if (col.changed) {
                                    col.changed = false;
                                    col.selected = !col.selected;
                                }
                            }

                            if (col.selected) {
                                if ((col.idx - lastSelectedIdx) <= 1) {
                                    col.grpIndex = scope.grpIndex;
                                    colAssignPeriod(col, grpStart, col.idx);
                                } else {
                                    scope.grpIndex = scope.grpIndex + 1;
                                    col.grpIndex = scope.grpIndex;
                                    grpStart = col.idx;
                                    colAssignPeriod(col, grpStart, col.idx);
                                }
                                lastSelectedIdx = col.idx;
                            } else {
                                col.grpIndex = null;
                            }

                        }
                    }

                    //console.log(JSON.stringify(scope.ngModel));
                }

                scope.onMouseMove = function (col) {
                    if (scope.isSelecting || scope.isDeselecting) {
                        if (scope.lastSelectedCell !== col) {
                            markAllToIndex(col.idx);
                        }

                        scope.lastSelectedCell = col;
                    }
                }


            }
        }
    }]);